import { render, staticRenderFns } from "./AwardBuyModal.vue?vue&type=template&id=668feea2"
import script from "./AwardBuyModal.vue?vue&type=script&lang=js"
export * from "./AwardBuyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports